import * as ActionType from './actionType'

const initialState = {
  productsData: null,
  pagination: null,
  selectedProduct: null,
  selectedVariation: null,
  variationImages: null,
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.FETCH_GET_PRODUCTS:
      return { ...state, ...action.payload }
    case ActionType.SELECT_PRODUCT: {
      const { id } = action.payload
      const selectedProduct = state.productsData.find((productObj) => productObj._id === id)
      return { ...state, selectedProduct }
    }
    case ActionType.SAVE_SELECT_PRODUCT: {
      return { ...state, ...action.payload }
    }
    case ActionType.SELECT_VARIATION: {
      const { id } = action.payload
      const selectedVariation = state.selectedProduct.variations.find((variationObj) => variationObj._id === id)
      return { ...state, selectedVariation }
    }
    case ActionType.FETCH_GET_VARIATION_IMAGES: {
      return { ...state, ...action.payload }
    }
    default:
      return state
  }
}

export default userReducer
